<template>
  <div class="o-container o-container--xlarge o-admin__home">
    <div class="o-grid o-grid--wrap">
      <div
        class="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-25@large"
      >
        <fair-navigation class="u-display-none u-display-block@large" />
        <marketing-teaser :teaserType="136" />
      </div>
      <div
        class="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-75@large"
      >
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import FairNavigation from '@/components/FairNavigation'
import MarketingTeaser from '@/components/MarketingTeaser'

export default {
  name: 'Fair',
  components: {
    FairNavigation,
    MarketingTeaser
  }
}
</script>

<style lang="scss" scoped>
.o-admin__home {
  padding: 4.5rem 0;

  section {
    margin-bottom: 8rem;
  }
}
</style>
